<template>
    <p class="text-white">Уведомление о выводе</p>
    <p class="text text-success">Напоминание о безотзывных трансферах.</p>
    <p class="text">Компания Baisanar LLC предупреждает вас, что за точность введенных реквизитов несет ответственность пользователь.</p>
    <p class="text">Все транзакции, совершаемые на сайте <b>xbt.kg</b> являются безотзывными.</p>
    <p class="text">Вернуть средства или отменить любые транзакции не представляется возможным по техническим причинам.</p>
    <p class="text">Просим вас проверять реквизиты многократно</p>
</template>